import type { TablePage } from './schemas'

/** Capacity is unfiltered server metadata, never the current page or visible columns. */
export function remainingCapacity(capacity: TablePage['capacity'], dimension: 'rows' | 'columns'): number {
  if (!capacity) return Infinity
  const other = dimension === 'rows' ? capacity.column_count : capacity.row_count
  const current = dimension === 'rows' ? capacity.row_count : capacity.column_count
  return other === 0 ? Infinity : Math.max(0, Math.floor(capacity.max_cells / other) - current)
}

export function additionLimitMessage(remaining: number, count: number, unit: 'documents' | 'rows' | 'columns'): string | undefined {
  if (count <= remaining) return undefined
  return remaining === 0
    ? `Adding more ${unit} would exceed this table's 1,000,000-cell limit. Remove documents, rows, or columns to make room.`
    : `You can add up to ${remaining.toLocaleString()} more ${unit} due to the table's 1,000,000-cell limit. Remove ${(
        count - remaining
      ).toLocaleString()} from your selection to continue.`
}
